

import Carousel from "../components/Carousel";
import WhySpecial from "../components/WhySpecial";
import MainServices from "../components/MainServices";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";


function Home() {

  return (
    <div>
      <Carousel/>
      <WhySpecial/>
      
      <MainServices/>
      
      <Testimonials/>
    </div>
  );
}

export default Home;
